/**
 * Forgot Password Page
 * Requirements: 6.7
 */
import React from 'react';
import { Box, Container } from '@mui/material';
import { ForgotPasswordForm } from '../components';

export const ForgotPasswordPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <ForgotPasswordForm />
      </Box>
    </Container>
  );
};
